import 'flexslider/jquery.flexslider'
import 'simplelightbox/dist/simple-lightbox.jquery.js'

function productGallery() {
  $('.woocommerce-product-gallery').flexslider({
    animation: 'slide',
    animationLoop: false,
    selector: '.woocommerce-product-gallery__wrapper > div',
  })

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

  if (!isMobile && $('.woocommerce-product-gallery__wrapper a').length) {
    $('.woocommerce-product-gallery__wrapper a').simpleLightbox()
  }
}

export default productGallery
